import React from 'react';
import { Box, Typography, Paper, Button, useTheme } from '@mui/material';
import { FaCheckCircle, FaArrowRight } from 'react-icons/fa';
import { IoMailOutline } from 'react-icons/io5';
import { IoCallOutline } from 'react-icons/io5';
import { PiRocketLaunchLight } from 'react-icons/pi';
import { FiUser } from 'react-icons/fi';

interface PaymentConfirmationStepProps {
  onNext: () => void | Promise<void>;
  onboardingData?: any;
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const PaymentConfirmationStep: React.FC<PaymentConfirmationStepProps> = ({ onNext, onboardingData }) => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        maxWidth: 720,
        mx: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: 1.5
      }}
    >
      {/* ✅ Payment Confirmed */}
      <Paper
        elevation={0}
        sx={{
          p: 1.5,
          borderRadius: 3,
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          background: 'white'
        }}
      >
        <FaCheckCircle color='green' size={20} />
        <Typography fontWeight={600} fontSize='14px' color='green'>
          Payment Confirmed
        </Typography>
      </Paper>

      {/* ✅ Main Card */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 4,
          background: theme.palette.primary.light
        }}
      >
        <Typography fontWeight={500} sx={{ fontSize: { xs: '16px', md: '20px' } }}>
          Share More Details for AI Receptionist Training
        </Typography>

        <Typography fontSize='12px' color='text.secondary' mt={0.5}>
          Answer a few questions about your business so our team can build your AI receptionist. Fill in what you know —
          your account manager will help with the rest.
        </Typography>

        <Button
          variant='contained'
          onClick={() => void onNext()}
          sx={{
            mt: 1.5,
            borderRadius: '30px',
            textTransform: 'none',
            background: theme.palette.primary.main,
            display: 'flex',
            alignItems: 'center',
            gap: 1
          }}
        >
          Few Steps Away, Lets Move <FaArrowRight />
        </Button>
      </Paper>

      {/* ✅ Setup Progress */}
      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 4,
          background: '#f3f4f6'
        }}
      >
        <Typography fontWeight={500} mb={2}>
          Meanwhile, we're setting things up
        </Typography>

        <Box display='flex' flexDirection='column' gap={2}>
          {[
            {
              icon: <FiUser />,
              label: 'Account Manager Assigned',
              time: '2–4 Hours'
            },
            {
              icon: <IoMailOutline />,
              label: 'Welcome Email from Your Account Manager',
              time: 'Within 24 hours'
            },
            {
              icon: <IoCallOutline />,
              label: 'Kickoff Call',
              time: 'Within 48 hours'
            },
            {
              icon: <PiRocketLaunchLight />,
              label: 'Agent Go-Live',
              time: 'Within 2 weeks of submission'
            }
          ].map((item, index) => (
            <Box key={index} display='flex' justifyContent='space-between' alignItems='center' gap={1}>
              <Box display='flex' alignItems='center' gap={1.5}>
                <Box fontSize='20px' color={theme.palette.primary.main}>
                  {item.icon}
                </Box>
                <Typography fontSize='14px'>{item.label}</Typography>
              </Box>

              <Typography fontSize='14px' color='text.secondary' sx={{ whiteSpace: 'nowrap' }}>
                {item.time}
              </Typography>
            </Box>
          ))}
        </Box>
      </Paper>
    </Box>
  );
};

export default PaymentConfirmationStep;
